module.exports = __webpack_public_path__ + "img/EDC8000_1-1.47b0b662.jpg";